/** Admin → AI paper trades: the tab in the URL (kept out of the lazily loaded page). */
export const AI_PAPER_TABS = ["instruments", "scoreboard", "who", "notice", "record", "shadow", "decision"] as const;
export type AiPaperTab = (typeof AI_PAPER_TABS)[number];

export interface AiPaperSearch {
  tab?: AiPaperTab;
}

/** The URL's search params (admin/sections.tsx). */
export function parseAiPaperSearch(s: Record<string, unknown>): AiPaperSearch {
  return AI_PAPER_TABS.includes(s.tab as AiPaperTab) && s.tab !== "instruments" ? { tab: s.tab as AiPaperTab } : {};
}
